import {FieldPath, useController} from "react-hook-form";
import React, {DetailedHTMLProps, InputHTMLAttributes} from "react";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {Control} from "react-hook-form/dist/types";
import {InputExProps} from "./InputEx";

interface Props<T extends FieldValues, CheckType = boolean> extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    control: Control<T>,
    name: FieldPath<T>,
    label?: string | React.ReactNode,
    checkValue?: CheckType,
    uncheckValue?: CheckType,
    onToggle?: (v: boolean | CheckType) => void, // N.B. nn posso usare onChange...
    divClassName?: string,
}

export function CheckboxEx<T extends FieldValues, CheckType = boolean>(props: Props<T, CheckType>) {
    const {
        label,
        control,
        name,
        checkValue = true,
        uncheckValue = false,
        type = 'checkbox',
        divClassName = '',
        ...rest
    } = props;

    const {
        field,
        fieldState: {error, isTouched, isDirty},
        formState: {touchedFields, dirtyFields, errors}
    } = useController({
        name,
        control,
    });

    const className = InputExProps.getClass({...props, error: error});

    return <div className={`flex items-center ${divClassName}`}>
        <input
            type={type}
            id={name}
            {...rest}
            value={'true'}
            checked={field.value === checkValue}
            onChange={(e) => {
                field.onChange(e.target.checked ? checkValue : uncheckValue)
                if (rest.onToggle) rest.onToggle(e.target.checked ? checkValue : uncheckValue);
            }}
            className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 disabled:opacity-50"
        />
        {label && <label htmlFor={name} className={`pl-2 block text-sm ${rest.disabled ? 'opacity-50' : ''}`}>
            {label}
        </label>}
    </div>;
}

export default CheckboxEx;